/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getExportTargetMappingRequestDataSchema = z.object({
	organisation: z.string().uuid(),
	campaign: z.string().uuid().nullable().optional(),
	perPage: z.number().nullable().optional().default(15),
})

export type GetExportTargetMappingRequestDataSchema = z.infer<typeof getExportTargetMappingRequestDataSchema>
